var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.338 38.6958C47.1885 39.1977 45.2415 40.2351 43.6563 41.6652L40.698 39.5481L37.293 44.4519L40.2873 46.5951C39.7713 47.9661 39.4881 49.4508 39.4881 51C39.4881 52.5495 39.7713 54.0342 40.2876 55.4052L37.2933 57.5478L40.698 62.4522L43.6566 60.3351C45.2418 61.7649 47.1885 62.8023 49.338 63.3042V66H55.248V63.3042C57.3975 62.8023 59.3442 61.7649 60.9291 60.3351L63.888 62.4522L67.2927 57.5478L64.2984 55.4052C64.8144 54.0342 65.0979 52.5495 65.0979 51C65.0979 49.4508 64.8147 47.9661 64.2984 46.5951L67.293 44.4519L63.8877 39.5481L60.9294 41.6652C59.3445 40.2351 57.3975 39.1977 55.248 38.6958V36H49.338V38.6958ZM52.293 44.3571C49.8555 44.3571 47.7465 45.5694 46.5255 47.3589C45.8085 48.4098 45.3981 49.6578 45.3981 51C45.3981 52.3425 45.8085 53.5905 46.5258 54.6414C47.7468 56.4306 49.8558 57.6429 52.293 57.6429C54.7302 57.6429 56.8392 56.4306 58.0602 54.6414C58.7772 53.5905 59.1879 52.3425 59.1879 51C59.1879 49.6578 58.7775 48.4098 58.0605 47.3589C56.8395 45.5694 54.7305 44.3571 52.293 44.3571Z",
    fill: "#F30002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2422 18C17.2422 10.9584 22.9506 5.25 29.9922 5.25C37.0337 5.25 42.7422 10.9584 42.7422 18C42.7422 25.0416 37.0337 30.75 29.9922 30.75C22.9506 30.75 17.2422 25.0416 17.2422 18Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8229 57.325L32.2004 60.75H5.24219V60C5.24219 47.9017 16.415 38.25 29.9922 38.25C31.3794 38.25 32.7443 38.3518 34.0765 38.5477L29.8225 44.674L28.979 45.8886L30.1816 46.7493L33.5663 49.1716C33.5069 49.7738 33.4764 50.3838 33.4764 51C33.4764 51.6162 33.5069 52.2261 33.5663 52.8283L30.1823 55.2497L28.9797 56.1102L29.8229 57.325Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetting);
export default __webpack_public_path__ + "static/media/user-setting.2c4822d7d1a2cc83eb7ff48692f6bb6f.svg";
export { ForwardRef as ReactComponent };